function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { useGridSelector } from "../../utils/index.js";
import { useGridRootProps } from "../../utils/useGridRootProps.js";
import { useGridPrivateApiContext } from "../../utils/useGridPrivateApiContext.js";
import { useGridApiEventHandler } from "../../utils/useGridApiEventHandler.js";
import { GridColumnHeaderItem } from "../../../components/columnHeaders/GridColumnHeaderItem.js";
import { gridColumnsTotalWidthSelector, gridGroupHeaderHeightSelector, gridHasFillerSelector, gridHeaderHeightSelector, gridVerticalScrollbarWidthSelector } from "../dimensions/gridDimensionsSelectors.js";
import { gridRenderContextColumnsSelector } from "../virtualization/index.js";
import { computeOffsetLeft } from "../virtualization/useGridVirtualScroller.js";
import { GridColumnGroupHeader } from "../../../components/columnHeaders/GridColumnGroupHeader.js";
import { gridColumnPositionsSelector, gridVisiblePinnedColumnDefinitionsSelector, gridColumnLookupSelector } from "../columns/index.js";
import { gridColumnGroupsUnwrappedModelSelector } from "../columnGrouping/gridColumnGroupsSelector.js";
import { GridScrollbarFillerCell as ScrollbarFiller } from "../../../components/GridScrollbarFillerCell.js";
import { getPinnedCellOffset } from "../../../internals/utils/getPinnedCellOffset.js";
import { GridColumnHeaderSeparatorSides } from "../../../components/columnHeaders/GridColumnHeaderSeparator.js";
import { gridClasses } from "../../../constants/gridClasses.js";
import { shouldCellShowLeftBorder, shouldCellShowRightBorder } from "../../../utils/cellBorderUtils.js";
import { PinnedColumnPosition } from "../../../internals/constants.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var GridColumnHeaderRow = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: function(_, styles) {
        return styles.columnHeaderRow;
    }
})({
    display: 'flex'
});
export var useGridColumnHeaders = function(props) {
    var visibleColumns = props.visibleColumns, sortColumnLookup = props.sortColumnLookup, filterColumnLookup = props.filterColumnLookup, columnHeaderTabIndexState = props.columnHeaderTabIndexState, columnGroupHeaderTabIndexState = props.columnGroupHeaderTabIndexState, columnHeaderFocus = props.columnHeaderFocus, columnGroupHeaderFocus = props.columnGroupHeaderFocus, headerGroupingMaxDepth = props.headerGroupingMaxDepth, columnMenuState = props.columnMenuState, columnVisibility = props.columnVisibility, columnGroupsHeaderStructure = props.columnGroupsHeaderStructure, hasOtherElementInTabSequence = props.hasOtherElementInTabSequence;
    var _React_useState = _sliced_to_array(React.useState(''), 2), dragCol = _React_useState[0], setDragCol = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(''), 2), resizeCol = _React_useState1[0], setResizeCol = _React_useState1[1];
    var apiRef = useGridPrivateApiContext();
    var rootProps = useGridRootProps();
    var columnGroupsModel = useGridSelector(apiRef, gridColumnGroupsUnwrappedModelSelector);
    var columnPositions = useGridSelector(apiRef, gridColumnPositionsSelector);
    var renderContext = useGridSelector(apiRef, gridRenderContextColumnsSelector);
    var pinnedColumns = useGridSelector(apiRef, gridVisiblePinnedColumnDefinitionsSelector);
    var columnsLookup = useGridSelector(apiRef, gridColumnLookupSelector);
    var offsetLeft = computeOffsetLeft(columnPositions, renderContext, pinnedColumns.left.length);
    var columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
    var gridHasFiller = useGridSelector(apiRef, gridHasFillerSelector);
    var headerHeight = useGridSelector(apiRef, gridHeaderHeightSelector);
    var groupHeaderHeight = useGridSelector(apiRef, gridGroupHeaderHeightSelector);
    var scrollbarWidth = useGridSelector(apiRef, gridVerticalScrollbarWidthSelector);
    var handleColumnResizeStart = React.useCallback(function(params) {
        return setResizeCol(params.field);
    }, []);
    var handleColumnResizeStop = React.useCallback(function() {
        return setResizeCol('');
    }, []);
    var handleColumnReorderStart = React.useCallback(function(params) {
        return setDragCol(params.field);
    }, []);
    var handleColumnReorderStop = React.useCallback(function() {
        return setDragCol('');
    }, []);
    var leftRenderContext = React.useMemo(function() {
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    var rightRenderContext = React.useMemo(function() {
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    useGridApiEventHandler(apiRef, 'columnResizeStart', handleColumnResizeStart);
    useGridApiEventHandler(apiRef, 'columnResizeStop', handleColumnResizeStop);
    useGridApiEventHandler(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    useGridApiEventHandler(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    var getColumnsToRender = function(params) {
        var _ref = params || {}, tmp = _ref.renderContext, currentContext = tmp === void 0 ? renderContext : tmp;
        var firstColumnToRender = currentContext.firstColumnIndex;
        var lastColumnToRender = currentContext.lastColumnIndex;
        var renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    var getFillers = function(params, children, leftOverflow) {
        var borderBottom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var isPinnedRight = (params === null || params === void 0 ? void 0 : params.position) === PinnedColumnPosition.RIGHT;
        var isNotPinned = (params === null || params === void 0 ? void 0 : params.position) === undefined;
        var hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        var leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ _jsxs(React.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ _jsx("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ _jsx("div", {
                    role: "presentation",
                    className: clsx(gridClasses.filler, borderBottom && gridClasses['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ _jsx(ScrollbarFiller, {
                    header: true,
                    pinnedRight: isPinnedRight,
                    borderBottom: borderBottom,
                    borderTop: false
                })
            ]
        });
    };
    var getColumnHeaders = function(params) {
        var other = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _getColumnsToRender = getColumnsToRender(params), renderedColumns = _getColumnsToRender.renderedColumns, firstColumnToRender = _getColumnsToRender.firstColumnToRender;
        var columns = [];
        for(var i = 0; i < renderedColumns.length; i += 1){
            var colDef = renderedColumns[i];
            var columnIndex = firstColumnToRender + i;
            var isFirstColumn = columnIndex === 0;
            var tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            var hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            var open = columnMenuState.open && columnMenuState.field === colDef.field;
            var pinnedPosition = params === null || params === void 0 ? void 0 : params.position;
            var pinnedOffset = getPinnedCellOffset(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            var siblingWithBorderingSeparator = pinnedPosition === PinnedColumnPosition.RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            var isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            var isLastUnpinned = columnIndex + 1 === columnPositions.length - pinnedColumns.right.length;
            var indexInSection = i;
            var sectionLength = renderedColumns.length;
            var showLeftBorder = shouldCellShowLeftBorder(pinnedPosition, indexInSection);
            var showRightBorder = shouldCellShowRightBorder(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller);
            columns.push(/*#__PURE__*/ _jsx(GridColumnHeaderItem, _extends({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isLastUnpinned: isLastUnpinned,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    var getColumnHeadersRow = function() {
        return /*#__PURE__*/ _jsxs(GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: gridClasses['row--borderBottom'],
            children: [
                leftRenderContext && getColumnHeaders({
                    position: PinnedColumnPosition.LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: PinnedColumnPosition.RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: GridColumnHeaderSeparatorSides.Left
                })
            ]
        });
    };
    var getColumnGroupHeaders = function(param) {
        var depth = param.depth, params = param.params;
        var _columnGroupsModel_firstColumnFieldToRender, _columnGroupsModel_lastColumnFieldToRender;
        var columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) {
            return null;
        }
        var firstColumnToRender = columnsToRender.firstColumnToRender, lastColumnToRender = columnsToRender.lastColumnToRender;
        var rowStructure = columnGroupsHeaderStructure[depth];
        var firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        var _columnGroupsModel_firstColumnFieldToRender_depth;
        var firstGroupToRender = (_columnGroupsModel_firstColumnFieldToRender_depth = (_columnGroupsModel_firstColumnFieldToRender = columnGroupsModel[firstColumnFieldToRender]) === null || _columnGroupsModel_firstColumnFieldToRender === void 0 ? void 0 : _columnGroupsModel_firstColumnFieldToRender[depth]) !== null && _columnGroupsModel_firstColumnFieldToRender_depth !== void 0 ? _columnGroupsModel_firstColumnFieldToRender_depth : null;
        var firstGroupIndex = rowStructure.findIndex(function(param) {
            var groupId = param.groupId, columnFields = param.columnFields;
            return groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender);
        });
        var lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        var _columnGroupsModel_lastColumnFieldToRender_depth;
        var lastGroupToRender = (_columnGroupsModel_lastColumnFieldToRender_depth = (_columnGroupsModel_lastColumnFieldToRender = columnGroupsModel[lastColumnFieldToRender]) === null || _columnGroupsModel_lastColumnFieldToRender === void 0 ? void 0 : _columnGroupsModel_lastColumnFieldToRender[depth]) !== null && _columnGroupsModel_lastColumnFieldToRender_depth !== void 0 ? _columnGroupsModel_lastColumnFieldToRender_depth : null;
        var lastGroupIndex = rowStructure.findIndex(function(param) {
            var groupId = param.groupId, columnFields = param.columnFields;
            return groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender);
        });
        var visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map(function(groupStructure) {
            return _extends({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter(function(field) {
                    return columnVisibility[field] !== false;
                })
            });
        }).filter(function(groupStructure) {
            return groupStructure.columnFields.length > 0;
        });
        var firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        var hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        var leftOverflow = hiddenGroupColumns.reduce(function(acc, field) {
            var column = columnsLookup[field];
            var _column_computedWidth;
            return acc + ((_column_computedWidth = column.computedWidth) !== null && _column_computedWidth !== void 0 ? _column_computedWidth : 0);
        }, 0);
        var columnIndex = firstColumnToRender;
        var children = visibleColumnGroupHeader.map(function(param, index) {
            var groupId = param.groupId, columnFields = param.columnFields;
            var hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            var tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            var headerInfo = {
                groupId: groupId,
                width: columnFields.reduce(function(acc, field) {
                    return acc + columnsLookup[field].computedWidth;
                }, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            var pinnedPosition = params.position;
            var pinnedOffset = getPinnedCellOffset(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            var indexInSection = index;
            if (pinnedPosition === PinnedColumnPosition.LEFT) {
                // Group headers can expand to multiple columns, we need to adjust the index
                indexInSection = columnIndex - 1;
            }
            return /*#__PURE__*/ _jsx(GridColumnGroupHeader, {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: shouldCellShowLeftBorder(pinnedPosition, indexInSection),
                showRightBorder: shouldCellShowRightBorder(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    var getColumnGroupHeadersRows = function() {
        if (headerGroupingMaxDepth === 0) {
            return null;
        }
        var headerRows = [];
        for(var depth = 0; depth < headerGroupingMaxDepth; depth += 1){
            headerRows.push(/*#__PURE__*/ _jsxs(GridColumnHeaderRow, {
                role: "row",
                "aria-rowindex": depth + 1,
                ownerState: rootProps,
                children: [
                    leftRenderContext && getColumnGroupHeaders({
                        depth: depth,
                        params: {
                            position: PinnedColumnPosition.LEFT,
                            renderContext: leftRenderContext,
                            maxLastColumn: leftRenderContext.lastColumnIndex
                        }
                    }),
                    getColumnGroupHeaders({
                        depth: depth,
                        params: {
                            renderContext: renderContext
                        }
                    }),
                    rightRenderContext && getColumnGroupHeaders({
                        depth: depth,
                        params: {
                            position: PinnedColumnPosition.RIGHT,
                            renderContext: rightRenderContext,
                            maxLastColumn: rightRenderContext.lastColumnIndex
                        }
                    })
                ]
            }, depth));
        }
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: getPinnedCellOffset,
        isDragging: !!dragCol,
        getInnerProps: function() {
            return {
                role: 'rowgroup'
            };
        }
    };
};
